import gql from "graphql-tag";

export default gql`
  mutation DeleteUser($customerId: ID, $username: ID) {
    deleteUser(customerId: $customerId, username: $username) {
      id
    }
  }
`;
